module.exports = __webpack_public_path__ + "static/media/gallery3.5e3ae531.png";